import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class BadRequestError extends GenericError {
}
export class NotFoundError extends GenericError {
}
export class InternalServerError extends GenericError {
}
export class NoSuchUploadError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NoSuchUploadError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AccessControlListNotSupportedError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AccessControlListNotSupportedError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AccessDeniedError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AccessDeniedError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AccessPointAlreadyOwnedByYouError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AccessPointAlreadyOwnedByYouError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AccountProblemError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AccountProblemError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AllAccessDisabledError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AllAccessDisabledError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AmbiguousGrantByEmailAddressError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AmbiguousGrantByEmailAddressError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class AuthorizationHeaderMalformedError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AuthorizationHeaderMalformedError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class BadDigestError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "BadDigestError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class EntityTooSmallError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "EntityTooSmallError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class EntityTooLargeError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "EntityTooLargeError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class ExpiredTokenError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "ExpiredTokenError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class IllegalLocationConstraintExceptionError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "IllegalLocationConstraintExceptionError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class IllegalVersioningConfigurationExceptionError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "IllegalVersioningConfigurationExceptionError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class IncompleteBodyError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "IncompleteBodyError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InlineDataTooLargeError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InlineDataTooLargeError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InternalError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InternalError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidAccessKeyIdError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidAccessKeyIdError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidArgumentError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidArgumentError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidBucketNameError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidBucketNameError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidBucketStateError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidBucketStateError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidDigestError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidDigestError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidLocationConstraintError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidLocationConstraintError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidObjectStateError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidObjectStateError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidPartError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidPartError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidPartOrderError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidPartOrderError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidPayerError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidPayerError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidPolicyDocumentError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidPolicyDocumentError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidRangeError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidRangeError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidRequestError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidRequestError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidSecurityError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidSecurityError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidTokenError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidTokenError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidURIError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidURIError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class KeyTooLongError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "KeyTooLongError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class MaxMessageLengthExceededError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "MaxMessageLengthExceededError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class MetadataTooLargeError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "MetadataTooLargeError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class MissingContentLengthError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "MissingContentLengthError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class MissingRequestBodyError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "MissingRequestBodyError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class MissingSecurityHeaderError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "MissingSecurityHeaderError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class NoSuchBucketError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NoSuchBucketError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class NoSuchBucketPolicyError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NoSuchBucketPolicyError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class NoSuchCORSConfigurationError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NoSuchCORSConfigurationError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class NoSuchKeyError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NoSuchKeyError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class NotImplementedError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NotImplementedError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class RequestHeaderSectionTooLargeError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "RequestHeaderSectionTooLargeError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class RequestTimeoutError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "RequestTimeoutError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class RequestTimeTooSkewedError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "RequestTimeTooSkewedError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class ServerSideEncryptionConfigurationNotFoundError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "ServerSideEncryptionConfigurationNotFoundError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class ServiceUnavailableError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "ServiceUnavailableError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class SignatureDoesNotMatchError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "SignatureDoesNotMatchError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class SlowDownError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "SlowDownError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class TokenRefreshRequiredError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "TokenRefreshRequiredError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class UnexpectedContentError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "UnexpectedContentError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class UserKeyMustBeSpecifiedError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "UserKeyMustBeSpecifiedError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class EtagIsMissingError extends GenericError {
    constructor() {
        super('EtagIsMissingError');
        this.name = "EtagIsMissingError";
        this.message = 'Etag is missing in the response headers';
    }
}
export class AuthorizationQueryParametersError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "AuthorizationQueryParametersError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class ConditionalRequestConflictError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "ConditionalRequestConflictError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class EndpointNotFoundError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "EndpointNotFoundError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class IncorrectEndpointError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "IncorrectEndpointError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidAccessPointError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidAccessPointError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidAccessPointAliasError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidAccessPointAliasError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidAddressingHeaderError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidAddressingHeaderError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidEncryptionAlgorithmError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidEncryptionAlgorithmError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidHostHeaderError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidHostHeaderError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidSessionExceptionError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidSessionExceptionError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidSignatureError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidSignatureError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class InvalidStorageClassError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "InvalidStorageClassError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class MissingAuthenticationTokenError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "MissingAuthenticationTokenError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class TokenCodeInvalidError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "TokenCodeInvalidError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class UnauthorizedAccessError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "UnauthorizedAccessError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class UnexpectedIPError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "UnexpectedIPError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class UnsupportedArgumentError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "UnsupportedArgumentError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class UnsupportedSignatureError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "UnsupportedSignatureError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export class NoSuchAccessPointError extends GenericError {
    constructor(error) {
        super(error.name);
        this.name = "NoSuchAccessPointError";
        this.code = error.code;
        this.requestId = error.requestId;
        this.resource = error.resource;
        this.message = error.message;
    }
}
export default {
    GenericError,
    BadRequestError,
    InternalServerError,
    NotFoundError,
    NoSuchUploadError,
    AccessControlListNotSupportedError,
    AccessDeniedError,
    AccessPointAlreadyOwnedByYouError,
    AccountProblemError,
    AllAccessDisabledError,
    AmbiguousGrantByEmailAddressError,
    AuthorizationHeaderMalformedError,
    BadDigestError,
    EntityTooSmallError,
    EntityTooLargeError,
    ExpiredTokenError,
    IllegalLocationConstraintExceptionError,
    IllegalVersioningConfigurationExceptionError,
    IncompleteBodyError,
    InlineDataTooLargeError,
    InternalError,
    InvalidAccessKeyIdError,
    InvalidArgumentError,
    InvalidBucketNameError,
    InvalidBucketStateError,
    InvalidDigestError,
    InvalidLocationConstraintError,
    InvalidObjectStateError,
    InvalidPartError,
    InvalidPartOrderError,
    InvalidPayerError,
    InvalidPolicyDocumentError,
    InvalidRangeError,
    InvalidRequestError,
    InvalidSecurityError,
    InvalidTokenError,
    InvalidURIError,
    KeyTooLongError,
    MaxMessageLengthExceededError,
    MetadataTooLargeError,
    MissingContentLengthError,
    MissingRequestBodyError,
    MissingSecurityHeaderError,
    NoSuchBucketError,
    NoSuchBucketPolicyError,
    NoSuchCORSConfigurationError,
    NoSuchKeyError,
    NotImplementedError,
    RequestHeaderSectionTooLargeError,
    RequestTimeoutError,
    RequestTimeTooSkewedError,
    ServerSideEncryptionConfigurationNotFoundError,
    ServiceUnavailableError,
    SignatureDoesNotMatchError,
    SlowDownError,
    TokenRefreshRequiredError,
    UnexpectedContentError,
    UserKeyMustBeSpecifiedError,
    EtagIsMissingError,
    AuthorizationQueryParametersError,
    ConditionalRequestConflictError,
    EndpointNotFoundError,
    IncorrectEndpointError,
    InvalidAccessPointError,
    InvalidAccessPointAliasError,
    InvalidAddressingHeaderError,
    InvalidEncryptionAlgorithmError,
    InvalidHostHeaderError,
    InvalidSessionExceptionError,
    InvalidSignatureError,
    InvalidStorageClassError,
    MissingAuthenticationTokenError,
    TokenCodeInvalidError,
    UnauthorizedAccessError,
    UnexpectedIPError,
    UnsupportedArgumentError,
    UnsupportedSignatureError,
    NoSuchAccessPointError,
};
